import footer from "./footer"
import navMenu from './headNav'
import page from './page'
import companyInfor from "./companyInfor"
import riskCompliance from "./riskCompliance"
import regulatoryTechProduct from "./regulatoryTechProduct"
import talentRecruitment from "./talentRecruitment"
export default {
    footer: footer,
    navMenu: navMenu,
    page: page,
    companyInfor: companyInfor,
    riskCompliance: riskCompliance,
    regulatoryTechProduct: regulatoryTechProduct,
    talentRecruitment: talentRecruitment,
}